<template>
  <div id="FactSheetPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-10-desktop is-12-tablet is-12-mobile">
        <h1 class="title">FACT SHEET MANAGER</h1>
        <h1
          v-if="display_list && display_list.length > 0"
          class="subtitle is-6"
        >
          Total {{ display_list.length }} rows founds
        </h1>
      </div>
      <div class="column is-10-desktop is-12-tablet is-12-mobile">
        <b-field>
          <b-input
            placeholder="Search by Unit ID or Agent Name..."
            type="search"
            icon="magnify"
            icon-clickable
            @input="filterFactSheetList"
          >
          </b-input>
        </b-field>
      </div>
      <div class="column is-2-desktop is-12-tablet is-12-mobile">
        <b-button
          expanded
          type="is-primary"
          icon-left="plus"
          @click.prevent="presentCreateFactSheetForm()"
        >
          New Fact
        </b-button>
      </div>
    </div>

    <div class="container">
      <div v-if="display_list">
        <b-table striped hoverable :data="display_list">
          <template slot-scope="props">
            <b-table-column field="document_number" label="ID" sortable>
              {{ props.row.document_number ? props.row.document_number : "-" }}
            </b-table-column>

            <b-table-column
              field="create_date"
              label="Created Date"
              width="220"
              sortable
            >
              {{ props.row.create_date | dateformatter }}
            </b-table-column>

            <b-table-column field="name" label="Client Name">
              {{ props.row.client.full_name }}
              ( {{ props.row.client.nick_name }} )
            </b-table-column>

            <b-table-column field="client.dob" label="Age" centered>
              {{ props.row.client.dob | yearolds }}
            </b-table-column>

            <b-table-column field="client.gender" label="Gender">
              <b-tag v-if="props.row.client.gender === 'M'" type="is-info">
                <b>Male</b>
              </b-tag>
              <b-tag
                v-else-if="props.row.client.gender === 'F'"
                type="is-danger"
              >
                <b>Female</b>
              </b-tag>
              <b-tag v-else type="is-info"> Others </b-tag>
            </b-table-column>

            <b-table-column field="create_by" label="Created By" sortable>
              {{ props.row.create_by }}
            </b-table-column>
            <b-table-column field="action" label="Action">
              <div class="buttons">
                <b-button
                  outlined
                  size="is-small"
                  type="is-primary"
                  icon-right="pencil"
                  @click="navigateToFactSheetUpdate(props.row)"
                />
                <b-button
                  outlined
                  size="is-small"
                  type="is-primary"
                  icon-right="download"
                  @click="requestDownloadFactsheet(props.row)"
                />
                <b-button
                  outlined
                  size="is-small"
                  type="is-danger"
                  icon-right="delete"
                  @click="presentRemoveFactSheetForm(props.row)"
                />
              </div>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon
                    icon="emoticon-sad-outline"
                    size="is-large"
                    type="is-primary"
                  />
                </p>
                <p>No any factsheet here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div v-else>
        <section class="hero is-medium">
          <div class="hero-body">
            <div class="container">
              <h2 class="title is-4">Loading...</h2>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Helpers from "@/utils/Helper";
import FactsheetApi from "@/services/FactsheetApi";
import AlertManager from "@/utils/AlertManager";

import NewFactsheetOptionForm from "@/components/forms/NewFactsheetOptionForm.vue";

export default {
  name: "FactSheetPage",
  computed: mapState(["user_profile"]),
  data() {
    return {
      factList: null,
      display_list: null
    };
  },
  filters: {
    yearolds: function(value) {
      if (!value) return "";
      return Helpers.ageCalculator(value);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatterWithTime(value);
    },
    birthdateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatter(value);
    }
  },
  methods: {
    filterFactSheetList: function(value) {
      const lowercase_value = value.toLowerCase();
      let filtered = this.factList.filter(factsheet => {
        return (
          (factsheet.create_by &&
            factsheet.create_by.toLowerCase().includes(lowercase_value)) ||
          (factsheet.document_number &&
            factsheet.document_number.toLowerCase().includes(lowercase_value))
        );
      });
      this.display_list = filtered;
    },
    presentCreateFactSheetForm: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: NewFactsheetOptionForm,
        events: {
          option_selected: value => {
            this.navigateToFactSheetCreate(value);
          }
        }
      });
    },
    navigateToFactSheetCreate: function(create_option) {
      this.$router.push({
        name: "factsheet-manage",
        query: { clientId: create_option.client_id }
      });
    },
    navigateToFactSheetUpdate: function(selected) {
      this.$router.push({
        name: "factsheet-manage",
        query: { factsheetId: selected._id }
      });
    },
    presentRemoveFactSheetForm: function(selected_factsheet) {
      this.$buefy.dialog.confirm({
        title: "Confirm Remove Factsheet",
        message:
          "Are you sure you want to permanently remove factsheet of <b>" +
          selected_factsheet.client.full_name +
          " </b> created on <b>" +
          Helpers.dateFormatterWithTime(selected_factsheet.create_date) +
          "</b> from the system?",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.requestRemoveFactsheet(selected_factsheet._id)
      });
    },
    performGetFactSheetByRole: async function() {
      await this.requestGetFactsheetList();
    },
    requestGetFactsheetList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await FactsheetApi.requestFactsheetList();
      loadingComponent.close();
      if (response.status) {
        this.factList = response.payload;
        this.display_list = response.payload.reverse();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestRemoveFactsheet: async function(fact_id) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await FactsheetApi.requestRemoveFactsheetById(fact_id);
      loadingComponent.close();
      if (response.status) {
        AlertManager.showSuccessSnackbar(response.message);
        this.performGetFactSheetByRole();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestDownloadFactsheet: async function(selected_factsheet) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await FactsheetApi.requestDownloadFactsheetById(
        selected_factsheet._id
      );
      loadingComponent.close();
      if (response.status === false) {
        AlertManager.showErrorSnackbar(response.message);
      } else {
        var underscored_name = selected_factsheet.client.full_name.replace(
          / /g,
          "_"
        );
        const file_name = "factsheet_" + underscored_name + ".pdf";

        const blob = new Blob([response], { type: "application/pdf" });
        const link = document.createElement("a");
        const URL = window.URL.createObjectURL(blob);
        link.href = URL;
        link.download = file_name;
        link.click();
        window.open(URL, "_blank");
      }
    }
  },
  async beforeMount() {
    await this.performGetFactSheetByRole();
  }
};
</script>
<style scoped></style>
